import { Button, Input } from '@platform/components';
import cx from 'classix';
import { useState } from 'react';

const SocialImpactNews = ({ backgroundColor }: { backgroundColor: 'gray' | 'blue' }) => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');

  const openNewsletterSubscribePage = () => {
    let [firstName, lastName] = ['', ''];
    const nameParts = name.split(' ');

    if (nameParts.length) {
      firstName = nameParts[0];
      lastName = nameParts.slice(1).join(' ');
    }

    document.location = `https://movingworlds.org/newsletter-subscribe?firstname=${firstName}&lastName=${lastName}&email=${email}`;
  };

  return (
    <div
      className={cx(
        'sm:-mb-12 flex flex-col items-center w-full p-10 gap-4',
        backgroundColor === 'blue' ? 'bg-secondary-brand-25' : 'bg-gray-25',
      )}
    >
      <h2 className='mb-3 font-header font-semibold text-gray-500 text-4xl leading-7'>
        Social Impact News
      </h2>
      <p>A monthly content round-up to help you scale your impact.</p>
      <form className='flex items-center gap-3'>
        <Input
          type='inline'
          placeholder='Name'
          value={name}
          onChange={(e) => {
            setName(e.target.value);
          }}
        />
        <Input
          type='inline'
          placeholder='Email'
          value={email}
          onChange={(e) => {
            setEmail(e.target.value);
          }}
        />
        <Button size='xl' variant='primary' onClick={(_e) => openNewsletterSubscribePage()}>
          Subscribe
        </Button>
      </form>
    </div>
  );
};

export default SocialImpactNews;
